
import Header from './Header'
import Promotion from './Promotion'
import Title from './Title'
import Button from './Button'
import Template from './Template'
import Dropdown from './Dropdown'
import Footer from './Footer'
import Components from './Components'
import MobileMenu from './MobileMenu'

export default {
    ...Header,
    ...Promotion,
    ...Title,
    ...Button,
    ...Template,
    ...Dropdown,
    ...Footer,
    ...Components,
    ...MobileMenu
}
